// in src/posts.js
import React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import {
    SelectField,
    BooleanField,
    ImageField,
    DateField,
    RichTextField,
    Show,
    SimpleShowLayout,
    SimpleList,
    List,
    Datagrid,
    ReferenceField,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
    BooleanInput,
    Filter
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import InputUploadInput from '../mui/field/UploadInput';
import { OnlyShowActionsList, OnlyShowActionsEdit, DontDeletectionsDetail } from './FieldComponents/OnlyShowActions';
import Validators from './renderFields/validatorsFields';

const CardFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="title" alwaysOn />
    </Filter>
);

export const CardList = (props) => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <List {...props} filters={<CardFilter />} title="Listar Tarjetas">
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.title}
                    secondaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="title" label="Título" />
                    <ReferenceField label="Subpágina ID" source="subpageId" reference="SubPages">
                        <TextField source="title" />
                    </ReferenceField>
                    <BooleanField source="state" label="Estado" />
                    <EditButton />
                </Datagrid>
            )}
        </List>
    );
};

const CardTitle = ({ record }) => {
    return <span>Tarjeta {record ? `"${record.title}"` : ''}</span>;
};

export const CardEdit = (props) => (
    <Edit title={<CardTitle />} {...props} actions={<OnlyShowActionsEdit />}>
        <SimpleForm>
            <TextInput source="id" disabled />
            <TextInput source="title" label="Título" validate={[Validators.required]} />
            <ReferenceInput label="Subpágina" source="subpageId" reference="SubPages" allowEmpty>
                <SelectInput optionText="title" />
            </ReferenceInput>
            <InputUploadInput source="image" label="Imagen" validate={[Validators.required]} />
            <RichTextInput source="description" label="Descripción" validate={[Validators.required]} />
            <TextInput source="phone" label="Teléfono" />
            <TextInput source="address" label="Dirección" />
            <BooleanInput label="Estado" source="state" />
        </SimpleForm>
    </Edit>
);

export const CardCreate = (props) => (
    <Create {...props} title="Crear Tarjeta">
        <SimpleForm>
            <TextInput source="title" label="Título" validate={[Validators.required]} />
            <ReferenceInput label="SubPágina" source="subpageId" reference="SubPages" allowEmpty>
                <SelectInput optionText="title" />
            </ReferenceInput>
            <InputUploadInput source="image" label="Imagen" validate={[Validators.required]} />
            <RichTextInput source="description" label="Descripción" validate={[Validators.required]} />
            <TextInput source="phone" label="Teléfono" />
            <TextInput source="address" label="Dirección" />
            <BooleanInput label="Estado" source="state" />
        </SimpleForm>
    </Create>
);

export const CardShow = (props) => (
    <Show title={<CardTitle />} {...props} actions={<DontDeletectionsDetail />}>
        <SimpleShowLayout>
            <TextField source="title" label="Título" />
            <RichTextField source="description" label="Descripción" />
            <ImageField source="image" label="Imagen" />
            <TextField source="page" label="Página ID" />
            <BooleanField source="state" label="Estado" />
            <DateField source="updatedAt" label="Fecha Actualización" />
            <DateField source="createdAt" label="Fecha Publicación" />
        </SimpleShowLayout>
    </Show>
);
